import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { endPoint } from "constants/server/api";
import { createFetchLogicPrototype } from "../../utils/fetchFactory";
import { createSlicePrototype } from "../../utils/sliceFactory";
import { http } from "utils/http";
var updateNewReceiptSlice = createSlicePrototype({
    name: "updateNewReceipt"
});
export var updateNewReceipt = createFetchLogicPrototype({
    actions: updateNewReceiptSlice.actions,
    configFn: function(param, param1) {
        var id = param.id, payload = param.payload, accessToken = param1.accessToken;
        return {
            method: "patch",
            url: "".concat(endPoint.NEW_RECEIPT, "/").concat(id),
            headers: {
                Authorization: "Bearer ".concat(accessToken)
            },
            data: payload
        };
    },
    onError: function(error, param) {
        var modalObj = param.modalObj, setModalObj = param.setModalObj;
        var getStatus = function(err) {
            return http.isAxiosError(err) && err.response ? err.response.status : 500;
        };
        var getMessage = function(err) {
            return http.isAxiosError(err) && err.response ? err.response.data.message : "เกิดข้อผิดพลาด\nหรือเครือข่ายขัดข้อง";
        };
        setModalObj === null || setModalObj === void 0 ? void 0 : setModalObj(_object_spread_props(_object_spread({}, modalObj), {
            visible: true,
            subTitle: "รหัส ".concat(getStatus(error)),
            navigateDirection: undefined,
            title: getMessage(error)
        }));
    }
});
export var clearUpdateNewReceipt = function() {
    return function(dispatch) {
        dispatch(updateNewReceiptSlice.actions.resetState());
    };
};
var _updateNewReceiptSlice_actions = updateNewReceiptSlice.actions;
export var fetchData = _updateNewReceiptSlice_actions.fetchData, fetchDataSuccess = _updateNewReceiptSlice_actions.fetchDataSuccess, fetchDataFailure = _updateNewReceiptSlice_actions.fetchDataFailure, resetState = _updateNewReceiptSlice_actions.resetState;
export default updateNewReceiptSlice.reducer;
